import { getSessionToken } from '@descope/react-sdk';
import axios from 'axios';
import { generateUUID } from '../helpers/uuidHelper';

let _userId = '';

axios.defaults.baseURL = process.env.REACT_APP_API_URL + '/api';
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000;

axios.interceptors.request.use(
  (config) => {
    const sessionToken = getSessionToken();
    config.headers['correlation-id'] = generateUUID();
    config.headers['Authorization'] = `Bearer ${sessionToken}`;
    config.headers['x-app-type'] = process.env.REACT_APP_APP_TYPE;
    config.headers['x-user-id'] = _userId;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // A 401 normally means the session is gone, so the app sends you back to
    // the landing route. A call that is allowed to fail quietly opts out with
    // skipAuthRedirect, so one non-critical lookup cannot throw the user off
    // a half-filled form.
    if (error.response && error.response.status === 401 && !error.config?.skipAuthRedirect) {
      window.location.href = '/';
      return;
    }
    // console.log(error.response?.data)
    if (error.response?.data?.message) {
      error.userMessage = error.response.data.message;
    }
    if (error.response?.data?.logId) {
      console.error(`[API Error] log id: ${error.response.data.logId}`);
    }
    return Promise.reject(error);
  }
);

export const setApiUserId = (userId) => {
  if (userId) {
    _userId = userId;
  }
  _userId = userId;
};